import { Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';

import { FullPageSpinnerRingStyles } from './fullPageSpinner.styles.ts';

type Props = {
  caption?: string;
};

export const FullPageSpinner: React.FC<Props> = props => {
  const { caption } = props;
  return (
    <Container>
      <Stack
        spacing={4}
        sx={[
          {
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          },
          ...(Array.isArray(FullPageSpinnerRingStyles)
            ? FullPageSpinnerRingStyles
            : [FullPageSpinnerRingStyles]),
        ]}
      >
        <CircularProgress size={64} sx={{ color: themeColors.accentColor }} />
        {caption && <Typography variant="f16Regular">{caption}</Typography>}
      </Stack>
    </Container>
  );
};
